import { useTranslation } from 'react-i18next';

export function useEquipmentLabels() {
  return useTranslation('app', { keyPrefix: 'equipmentIntro' }).t;
}

export default function useEquipment(equipment) {
  const { t, i18n } = useTranslation('equipment', { keyPrefix: equipment.id });
  return equipment.present(t, i18n.resolvedLanguage || i18n.language);
}
